import store from '../../../data/redux/Store'
import {DocumentsApiSlice} from './DocumentsApiSlice'

function applyPreviewWindowBaseStyles(previewWindow: Window) {
  previewWindow.document.documentElement.style.margin = '0'
  previewWindow.document.documentElement.style.padding = '0'
  previewWindow.document.documentElement.style.background = '#062f3d'
  previewWindow.document.body.style.margin = '0'
  previewWindow.document.body.style.padding = '0'
  previewWindow.document.body.style.background = '#062f3d'
}

function renderLoadingState(previewWindow: Window) {
  previewWindow.document.title = 'Opening document...'
  applyPreviewWindowBaseStyles(previewWindow)
  previewWindow.document.body.innerHTML = `
    <div style="margin:0;min-height:100vh;display:flex;align-items:center;justify-content:center;background:#062f3d;color:#fff;font-family:Segoe UI,Arial,sans-serif;">
      <div style="text-align:center;opacity:.9;">
        <div style="width:32px;height:32px;border:3px solid rgba(255,255,255,.2);border-top-color:#00a3ff;border-radius:50%;margin:0 auto 12px;animation:spin .8s linear infinite;"></div>
        <div style="font-size:14px;">Opening document...</div>
      </div>
    </div>
    <style>html,body{margin:0;padding:0;background:#062f3d;}@keyframes spin{to{transform:rotate(360deg)}}</style>
  `
}

function renderErrorState(previewWindow: Window, message: string) {
  previewWindow.document.title = 'Document unavailable'
  applyPreviewWindowBaseStyles(previewWindow)
  previewWindow.document.body.innerHTML = `
    <div style="margin:0;min-height:100vh;display:flex;align-items:center;justify-content:center;background:#062f3d;color:#fff;font-family:Segoe UI,Arial,sans-serif;padding:24px;">
      <div style="max-width:420px;text-align:center;">
        <div style="font-size:16px;font-weight:600;margin-bottom:8px;">Unable to open document</div>
        <div style="font-size:14px;color:rgba(255,255,255,.72);">${message}</div>
      </div>
    </div>
    <style>html,body{margin:0;padding:0;background:#062f3d;}</style>
  `
}

async function convertBase64ToBlobUrl(base64String: string, fileType: string): Promise<string> {
  const response = await fetch(`data:${fileType};base64,${base64String}`)
  const blob = await response.blob()
  return URL.createObjectURL(blob)
}

export async function previewDocumentInNewTab(documentId: string) {
  const previewWindow = window.open('', '_blank')
  if (!previewWindow) return

  previewWindow.opener = null
  renderLoadingState(previewWindow)

  try {
    const result = await store.dispatch(
      DocumentsApiSlice.endpoints.getDocuments.initiate([documentId], {forceRefetch: true})
    ).unwrap()

    const file = result.entities[documentId]
    if (!file?.fileContent) {
      renderErrorState(previewWindow, 'The requested file could not be found.')
      return
    }

    const blobUrl = await convertBase64ToBlobUrl(file.fileContent, file.fileType)
    previewWindow.location.replace(blobUrl)
  } catch (error) {
    renderErrorState(previewWindow, 'Please try again from the current window.')
  }
}